export function clientHeadersMapper(
  headers: Record<string, string[]>,
): Record<string, string> {
  if (!headers) return {}
  else
    return Object.fromEntries(
      Object.entries(headers)
        .filter(([k]) => k.toLowerCase() !== 'host') // remove Host
        .map(([k, v]) => {
          const found = v?.find(
            (s) => typeof s === 'string' && s.trim().length > 0,
          )
          return [k, found?.trim() ?? '']
        }),
    )
}
